import { FormElementPropsWithoutProduct } from "../../../../components/Case/CaseForm/FormElement";
import { UseForm } from "../../../../types/UseForm";
import { postalCodeDefault } from "../../../validationRules";
import { ProductUnion } from "../../../../types/ProductUnion";

type AddressFieldsProps<T extends ProductUnion = ProductUnion> = {
  path: string;
  translationPath?: string;
  isDisabled?: ({ product, values }: { product: T; values: UseForm["values"] }) => boolean;
  isHidden?: ({ product, values }: { product: T; values: UseForm["values"] }) => boolean;
  hidePostOfficeBoxFields?: ({ product, values }: { product: T; values: UseForm["values"] }) => boolean;
  hideAddressAddition?: boolean;
};
export default function addressFields<T extends ProductUnion = ProductUnion>({
  path,
  translationPath = "",
  isDisabled = () => false,
  isHidden = () => false,
  hidePostOfficeBoxFields = () => true,
  hideAddressAddition = true,
}: AddressFieldsProps<T>) {
  translationPath = translationPath !== "" ? translationPath : path;

  const postalCodePath = `${path}.postalCode`;
  const addressLocalityPath = `${path}.addressLocality`;

  const formElementProps: FormElementPropsWithoutProduct<T>[] = [
    {
      type: "ValidatorGooglePlacesAutocomplete",
      path: `${path}.streetAddress`,
      translationPath,
      isDisabled,
      isHidden,
      additionalProps: {
        postalCodePath,
        addressLocalityPath,
      },
    },
    {
      type: "ValidatorTextField",
      path: postalCodePath,
      translationPath: `${translationPath}.postalCode`,
      isDisabled: isDisabled,
      isHidden: isHidden,
      validators: [postalCodeDefault],
    },
    {
      type: "ValidatorTextField",
      path: addressLocalityPath,
      translationPath: `${translationPath}.addressLocality`,
      isDisabled: isDisabled,
      isHidden: isHidden,
    },
    {
      type: "ValidatorTextField",
      path: `${path}.addressAddition`,
      translationPath: `${translationPath}.addressAddition`,
      isDisabled: isDisabled,
      isHidden: ({ product, values }) => hideAddressAddition || isHidden({ product, values }),
    },
    {
      type: "ValidatorTextField",
      path: `${path}.postOfficeBoxNumber`,
      translationPath: `${translationPath}.postOfficeBoxNumber`,
      isDisabled: isDisabled,
      isHidden: ({ product, values }) => hidePostOfficeBoxFields({ product, values }) || isHidden({ product, values }),
    },
    {
      type: "ValidatorTextField",
      path: `${path}.postOfficeBoxPostalCode`,
      translationPath: `${translationPath}.postOfficeBoxPostalCode`,
      isDisabled: isDisabled,
      isHidden: ({ product, values }) => hidePostOfficeBoxFields({ product, values }) || isHidden({ product, values }),
    },
    {
      type: "ValidatorTextField",
      path: `${path}.postOfficeBoxAddressLocality`,
      translationPath: `${translationPath}.postOfficeBoxAddressLocality`,
      isDisabled: isDisabled,
      isHidden: ({ product, values }) => hidePostOfficeBoxFields({ product, values }) || isHidden({ product, values }),
    },
  ];
  return formElementProps;
}
